import React from 'react';
import { Grid } from '@mui/material';
import SearchableAutocomplete from '../../../SearchableAutocomplete';
import { toPersianDigits } from '../../../../utils/convertNumbers';

export default function CourseSelection({
    value,
    onChange,
    editRecord,
    disabled,
    formKey,
    onTeacherSelect
}) {
    return (
        <Grid item xs={12} md={6}>
            <SearchableAutocomplete
                key={`course-${formKey}`}
                apiUrl="/operations/api/v1/teachers-and-courses/"
                label="دوره"
                placeholder="جستجوی دوره..."
                value={value}
                onChange={(value, option) => {
                    onChange(value);
                    // Store teacher ID and course data
                    if (option?.teacher?.id) {
                        onTeacherSelect?.(option.teacher.id, option);
                    } else {
                        onTeacherSelect?.(null, null);
                    }
                }}
                getOptionLabel={(option) => {
                    if (!option) return '';
                    
                    // Workaround: if duration is missing, try to get it from editRecord
                    let durationValue = option.duration;
                    if (!durationValue && editRecord?.course?.id === option.id) {
                        durationValue = editRecord.course.duration;
                    }
                    
                    const teacherName = option.teacher 
                        ? `${option.teacher.first_name || ''} ${option.teacher.last_name || ''}`.trim() 
                        : 'بدون آموزگار';
                    const courseTypeLabel = option.course_type === 'individual' ? 'خصوصی' : 'گروهی';
                    const duration = durationValue ? `${toPersianDigits(durationValue)} دقیقه` : '';
                    const parts = [
                        option.course_name,
                        teacherName
                    ];
                    if (duration) {
                        parts.push(duration);
                    }
                    parts.push(`(${courseTypeLabel})`);
                    return parts.join(' - ');
                }}
                getOptionValue={(option) => option?.id}
                initialOption={
                    editRecord?.course
                        ? {
                            id: editRecord.course.id,
                            course_name: editRecord.course.course_name,
                            course_type: editRecord.course.course_type,
                            duration: editRecord.course.duration,
                            teacher: editRecord.course.teacher
                                ? {
                                    id: editRecord.course.teacher.id,
                                    first_name: editRecord.course.teacher.first_name,
                                    last_name: editRecord.course.teacher.last_name,
                                }
                                : null,
                        }
                        : null
                }
                params={{ archive_state: false }}
                disabled={disabled}
                required={false}
                size="small"
                sx={{
                    '& .MuiInputBase-root': {
                        height: '40px',
                        direction: 'rtl',
                    },
                }}
            />
        </Grid>
    );
}

